import { Button, Link, Tooltip } from "@heroui/react";
import { CopyIcon } from "lucide-react";
import { toast } from "sonner";
import { shortHex } from "../utils";

interface CompactHashProps {
  hash: string;
  href?: string;
  isExternal?: boolean;
  showAnchorIcon?: boolean;
}

export function CompactHash({
  hash,
  href,
  isExternal = false,
  showAnchorIcon = false,
}: CompactHashProps) {
  const displayHash = shortHex(hash);

  const handleCopy = () => {
    navigator.clipboard.writeText(hash);
    toast.info("Hash copied to clipboard");
  };

  const hashContent = href ? (
    <Link href={href} isExternal={isExternal} showAnchorIcon={showAnchorIcon}>
      {displayHash}
    </Link>
  ) : (
    <span className="font-mono">{displayHash}</span>
  );

  return (
    <div className="inline-flex items-center gap-1">
      <Tooltip
        content={
          <div className="font-mono text-xs break-all max-w-md">
            {hash}
          </div>
        }
        placement="top"
        delay={200}
      >
        {hashContent}
      </Tooltip>
      <Button
        variant="light"
        size="sm"
        isIconOnly
        onPress={handleCopy}
        className="min-w-unit-6 w-unit-6 h-unit-6"
      >
        <CopyIcon size={12} />
      </Button>
    </div>
  );
}
